import { ApiError } from './http';

/**
 * Mensagem para a pessoa a partir de um erro: usa o `detail` da API (já em pt-BR e específico)
 * e só cai em texto genérico para falhas sem resposta.
 */
export function mensagemDeErro(erro: unknown): string {
  if (erro instanceof ApiError) {
    if (erro.status >= 500) return 'O serviço está indisponível agora. Tente de novo em instantes.';
    return erro.problem.errors?.[0]?.message ?? erro.message;
  }
  return 'Sem conexão com o servidor. Confira a rede e tente de novo.';
}
